import React from 'react';
import PropTypes from 'prop-types';
import { getEyebrowFromTags } from '../../utils';

const PlaylistCard = ({ item }) => {
  const { thumbnailUrlResize } = item;
  const [smImg, mdImg, lgImg] = thumbnailUrlResize;
  return (
    <a href={`/events/video/${item.slug}/${item.id}`}>
      <div className="card">
        <div>
          <p className="card__eyebrow">
            {getEyebrowFromTags(item?.internalTags)}
          </p>
          <h3 className="card__title">{item.title}</h3>
        </div>
        <div className="card__image_container">
          <img
            src={item.thumbnailUrl}
            alt={item.title}
            loading="lazy"
            srcSet={`${smImg} 229w, ${mdImg} 673w, ${lgImg} 420w`}
            sizes="(max-width: 640) 153px, (max-width: 920px) calc(100vw / 2 - 40px), 280px"
          />
        </div>
      </div>
    </a>
  );
};

PlaylistCard.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired
  }).isRequired
};

export default PlaylistCard;
